export default "__VITE_ASSET__DxW4a7Pk__"